var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"learner-guide-page-container",class:_vm.pageNumClass},[_c('div',{staticClass:"learner-guide-page-num"},[_c('span',[_vm._v(_vm._s(_vm.displayPage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }